import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { UserProfileResource } from './UserProfile';
import { VideoAskAnswerResource } from './VideoAskAnswer';

/**
 * Relationship classes
 */
export class VideoAskQuestionAttributes {
  id: string = null;
}

export class VideoAskQuestionBelongsTo {
  userProfile: () => UserProfileResource = () => new UserProfileResource();
  videoAskAnswer: () => VideoAskAnswerResource = () => new VideoAskAnswerResource();
}

export class VideoAskQuestionHasOne {}
export class VideoAskQuestionHasMany {}

/**
 * Utility interfaces
 */
export interface VideoAskQuestionMethods {}

export interface VideoAskQuestionInterface
  extends VideoAskQuestionAttributes,
    VideoAskQuestionBelongsTo,
    VideoAskQuestionType {}

type VideoAskQuestionType = GConstructor<VideoAskQuestionInterface>;

export interface VideoAskQuestionResource
  extends Base<VideoAskQuestionAttributes>,
    VideoAskQuestionInterface,
    VideoAskQuestionMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<VideoAskQuestionAttributes>({
    queryName: 'video_ask_questions',
    className: 'VideoAskQuestion',
    AttributesClass: VideoAskQuestionAttributes,
    BelongsToClasses: [
      {
        Klass: VideoAskQuestionBelongsTo,
      },
    ],
  });

export const VideoAskQuestionResourceClass = <TBase extends VideoAskQuestionType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements VideoAskQuestionMethods {};

export class VideoAskQuestionResource extends ClassExtender<VideoAskQuestionInterface>(
  BaseClass,
  VideoAskQuestionResourceClass,
) {}

/**
 * Resource instance
 */
export const VideoAskQuestion =
  APILibrary.createResource<VideoAskQuestionResource>(VideoAskQuestionResource);
